import { z } from 'zod';

export const OnboardingEmailRequestSchema = z.object({
  email: z.string().email(),
});

export const OnboardingEmailResponseSchema = z.object({
  message: z.string(),
});

export type OnboardingEmailRoute = never;
